import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {UserResponse} from "../../classes/user-response";

@Component({
  selector: 'repeater-type',
  templateUrl: 'repeater-type.html',
  styleUrls: ['repeater-type.css']
})
export class RepeaterType implements OnInit{

  //Inputs used to display questions

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() question_type : string;
  @Input() is_mandt : boolean;
  @Input() question_number : number;
  @Input() indexOfRepeater : number;
  @Input() userRes : string[];
  @Input() question_max_char: number;

  @Output() user_Resp = new EventEmitter<string[]>();

  regex : RegExp;
  max_allowed : number;
  value : number;

  ngOnInit(): void{
    this.max_allowed = this.question_max_char;
    if(this.userRes[this.indexOfRepeater] != undefined && this.userRes[this.indexOfRepeater].length > 0){
      this.value = parseInt(this.userRes[this.indexOfRepeater]);
    }
  }
  

  onPressNaturalWhole(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
 
    if(!isNaN(parseInt(event.target.value + inputChar)) && parseInt(event.target.value + inputChar) > this.max_allowed){
      event.preventDefault();
    }
   
  }

  onKeyNaturalWhole(event: any) {
    if(event.target.value.charAt(event.target.value.length-1) === " "){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  onEnterNaturalWhole(event: any){
    if(this.question_type==='N' && parseInt(event.target.value) === 0){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }else {
      this.value = event.target.value;
      this.user_Resp.emit([this.indexOfRepeater,this.question_number.toString(),event.target.value.toString()]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/questions-type/repeater-type/repeater-type.ts